export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null as string | null,
  }),

  getters: {
    isAuthenticated: state => !!state.token,
    getToken: state => state.token,
  },

  actions: {
    setAuth(token: string) {
      this.token = token

      useCookiee.set('partner_auth_token', token, {
        expires: 30,
        sameSite: 'lax',
        encrypt: false,
      })

      const api = useApi()
      api.setToken(token)
    },

    logout() {
      this.token = null

      const api = useApi()
      api.setToken(null)

      if (import.meta.client) {
        const nuxtApp = useNuxtApp()
        const queryClient = nuxtApp.$queryClient as any
        if (queryClient) {
          queryClient.clear()
        }
      }

      useCookiee.remove('partner_auth_token')
    },

    initFromStorage() {
      try {
        const token = useCookiee.get<string>('partner_auth_token', { encrypt: false })
        if (token) {
          this.token = token
          const api = useApi()
          api.setToken(token)
        }
      }
      catch (err) {
        console.error('Error initializing auth from storage:', err)
        this.logout()
      }
    },
  },
})
